import React from 'react';
import ProductHeader from './ProductHeader';
import ProductMediaContent from './ProductMediaContent';
import './ProductMediaArea.less';

const ProductMediaArea = (props) => {
  const { productDetail, getImagery, getProductDetail } = props;

  const isOwner = productDetail?.isOwner;

  return (
    <div className='product-media-area scroller--y'>
      <ProductHeader isOwner={isOwner} productDetail={productDetail} />
      <ProductMediaContent
        getImagery={getImagery}
        isOwner={isOwner}
        getProductDetail={getProductDetail}
      />
    </div>
  );
};
export default ProductMediaArea;
